'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useCachedHomeComposerInputVariation } from '#pplx/frontend/apps/ask/page-components/home/homeComposerInputFlag.js';
import { LegacyHomeInput } from '#pplx/frontend/apps/ask/page-components/home/LegacyHomeInput.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
const DynamicHomeComposer = Dynamic(async () => {
    const { HomeComposerPage } = await import('#pplx/frontend/apps/ask/page-components/home/HomeComposerPage.js');
    return { default: HomeComposerPage };
});
export function HomeInput(props) {
    const shouldUseHomeComposer = useCachedHomeComposerInputVariation({
        defaultValue: false,
    });
    if (shouldUseHomeComposer) {
        return _jsx(DynamicHomeComposer, { recessedFrame: props.recessedFrame });
    }
    return _jsx(LegacyHomeInput, { ...props });
}
//# sourceMappingURL=HomeInput.js.map